import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { Card, Flex, Typography } from "antd";
import React, { memo } from "react";
import { TicketManager, TicketTagBar, useTicketData } from "../../..";
import { TicketSourceTag } from "../../../source";
import { ColumnContext } from "../../context/ColumnContext";
import { KanbanContext } from "../../context/KanbanContext";
import { Dragger } from "../styled/Dragger";

type Props = {
  ticketManager: TicketManager;
  listeners?: SyntheticListenerMap;
  isDragging?: boolean;
  customReload?: () => void;
};

export const TicketListItem = memo((props: Props) => {
  const columnId = React.useContext(ColumnContext);
  const kanbanManager = React.useContext(KanbanContext);
  const ticketData = useTicketData();

  function reload() {
    if (kanbanManager && columnId) kanbanManager?.reload(columnId);
    else props.customReload?.();
  }
  return (
    <Card size="small" style={{ marginBottom: 8 }}>
      <Flex align="center" justify="space-between" wrap>
        <Flex align="center" gap="16px">
          {props.listeners && (
            <Dragger
              icon="fa:grip-lines"
              size={24}
              {...props.listeners}
              isdragging={props.isDragging ? "true" : "false"}
            />
          )}

          <Typography.Text strong>{ticketData?.ticket?.title}</Typography.Text>

          <TicketSourceTag
            filterManager={props.ticketManager}
            onClick={() => reload()}
          />
        </Flex>
        <Flex align="center" gap="16px" justify="flex-end" style={{ flex: 1 }}>
          <TicketTagBar
            reload={props.customReload}
            managers={{ filterManager: props.ticketManager }}
          />
        </Flex>
      </Flex>
    </Card>
  );
});
